import { Redirect } from 'expo-router';

export default function EventsIndexRedirect() {
  return <Redirect href="/events/upcoming" />;
}
